export function cleanTitle(title, authors) {
  let cleaned = title;

  authors.forEach(a => {
    // Skapa regex för varje namn, escape:a specialtecken
    const regex = new RegExp(a.name.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'), "g");
    cleaned = cleaned.replace(regex, "");
  });

  return cleaned.trim();
}


export function isUserMember(club, userId) {
  return club.members?.some(member => member.userId === userId);
}

export function sortMembersByProgress(members){
  return [...members].sort(
    (a,b) => b.readingProgress - a.readingProgress
  );
}


export function sortClubs(clubs, searchParams){
  if(!searchParams) return clubs

  const name = searchParams.name ? searchParams.name.toLowerCase() : "";
  const genre = searchParams.genre ? searchParams.genre: "";

  return clubs.filter(club => {
      const matchesName = club.clubName.toLowerCase().includes(name) ? true : false;
      const matchesGenre = club.genre.includes(genre) ? true : false;
      return matchesName && matchesGenre;
    }
  );
}

export function formatAsBook(searchResultId) {
  const authorField = searchResultId.author;
  const authorsArray = Array.isArray(authorField) ? authorField : authorField ? [authorField] : [];
  const authors = authorsArray.map(author => author?.name ?? "").filter(Boolean).join(", ");
  const pages = searchResultId.details.numPages ?? searchResultId.numPages ?? 0;
  const genre = searchResultId.bookGenres[0].name ?? "Unknown";
  return {
    bookId: searchResultId.legacyId,
    title: searchResultId?.title ?? "",
    author: authors,
    pages: pages,
    description: searchResultId?.description || "No description available.",
    bookImg: searchResultId?.imageUrl || "",
    genre: genre
  };
}

export function sortBooksByScore(books) {
  return books.slice().sort((a, b) => b.totalScore - a.totalScore);
}

export function stringToDate(dateString) {
  const date = new Date(dateString);
  if (isNaN(date.getTime())) {
    return null;
  } 
  return date;
}

export function formatNoteTimestamp(timestamp){
  const date = new Date(timestamp);

  const dateString = date.toLocaleDateString("sv-SE"); // t.ex. "2025-12-22"
  const timeString = date.toLocaleTimeString("sv-SE", { hour: '2-digit', minute: '2-digit' }); // t.ex. "14:35"

  return (`${dateString} ${timeString}`)
}

export function isDateInFuture(dateString) {
  const date = new Date(dateString);
  const now = new Date();
  return date > now;
}

export function arrayToObject(voters) {
  const obj = {};
  voters.forEach(voter => {
    obj[voter.userId] = voter.score;
  });
  return obj;
}


